import styled from '@emotion/styled'
import {
  InfoLarge600Style,
  InfoMediumMaxi600Style,
  InfoXXXLarge600Style,
  InfoMedium500Style,
} from '../../../../../styles/Text.styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9375rem;
  width: 100%;
  padding: 1rem 0rem;
`

export const TitleContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const TitleText = styled.div`
  ${InfoMedium500Style}
`

export const ValueText = styled.div`
  ${InfoLarge600Style}
`

export const Title = styled.h3`
  text-align: center;
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
`

// Styles for the scenario numbers section (previously BlackScenarioNumbers)
export const NumbersContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px;
  width: 100%;
  justify-content: center;

  flex: 1;
  min-width: 0;
  box-sizing: border-box;
`

export const TrippleWrapper = styled.div`
  flex: 1 1 10rem;
  max-width: 10rem;
  min-width: min-content;
`

// Styles for the tripple component (previously BlackTripple)
export const VStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
`

export const TopText = styled.div`
  ${InfoMediumMaxi600Style}
  font-family: 'Noto Sans', sans-serif;
`

export const MiddleText = styled.div`
  ${InfoXXXLarge600Style}
  font-family: 'Noto Sans', sans-serif;
`

export const BottomText = styled.div`
  ${InfoMedium500Style}
  font-family: 'Noto Sans', sans-serif;
`
